import {
  COUNTRY_SET_FOCUS,
  COUNTRY_SET,
  COUNTRY_SET_VALIDATION_MESSAGE,
  COUNTRY_SET_VISUALIZATION,
  COUNTRY_SET_API_ERROR,
  COUNTRY_SET_SUGGESTIONS,
  COUNTRY_SET_ID
} from 'src/app/redux/actions/registration/experience/experienceCountry';


const initialState = {
  // at the time I am writing this comment,
  // the vast majority of registrations is from Poland, so we decided to put it by default
  value: 'Polska',
  id: 1,
  isPoland: true,
  validationMessage: '',
  markedAsWrong: false,
  apiError: false,
  focus: false,
  disabled: false,
  suggestions: []
};

const experienceCountryReducer = (state = initialState, action = {}) => ({
  [COUNTRY_SET_API_ERROR]: () => ({ ...state, apiError: action.payload }),
  [COUNTRY_SET]: () => ({ ...state, ...action.payload }),
  [COUNTRY_SET_FOCUS]: () => ({ ...state, ...action.payload }),
  [COUNTRY_SET_VALIDATION_MESSAGE]: () => ({ ...state, ...action.payload }),
  [COUNTRY_SET_VISUALIZATION]: () => ({ ...state, ...action.payload }),
  [COUNTRY_SET_SUGGESTIONS]: () => ({ ...state, ...action.payload }),
  [COUNTRY_SET_ID]: () => ({ ...state, ...action.payload, isPoland: action.payload.id === 1 })
}[action.type] || (() => state))();

export default experienceCountryReducer;

